
import Layout from "../../components/feature/Layout";
import { useState } from "react";

export default function Integrations() {
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState<any>(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const showToast = (message: string) => {
    setToastMessage(message);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };

  const integrations = [
    {
      category: "Servicios Fiscales",
      items: [
        { id: 1, name: "SAT - Facturación Electrónica", description: "Timbrado y validación de CFDI", status: "Conectado", icon: "ri-file-text-line", color: "text-[#10B981]", lastSync: "Hace 5 min", syncCount: 1247 },
        { id: 2, name: "Buzón Tributario", description: "Consulta automática de notificaciones", status: "Conectado", icon: "ri-mail-line", color: "text-[#10B981]", lastSync: "Hace 1 hora", syncCount: 89 },
      ]
    },
    {
      category: "Servicios Bancarios",
      items: [
        { id: 3, name: "Bancos - Conciliación", description: "Sincronización de movimientos bancarios", status: "Conectado", icon: "ri-bank-line", color: "text-[#10B981]", lastSync: "Hace 30 min", syncCount: 3456 },
        { id: 4, name: "SPEI - Transferencias", description: "Envío y recepción de transferencias", status: "Disponible", icon: "ri-exchange-line", color: "text-gray-400", lastSync: "-", syncCount: 0 },
      ]
    },
    {
      category: "Servicios Aduanales",
      items: [
        { id: 5, name: "API Aduanas México", description: "Consulta de pedimentos y validaciones", status: "Conectado", icon: "ri-ship-line", color: "text-[#10B981]", lastSync: "Hace 15 min", syncCount: 892 },
        { id: 6, name: "Ventanilla Única", description: "Trámites digitales aduaneros", status: "Conectado", icon: "ri-government-line", color: "text-[#10B981]", lastSync: "Hace 2 horas", syncCount: 156 },
        { id: 7, name: "Tracking Navieras", description: "Seguimiento de contenedores", status: "Disponible", icon: "ri-map-pin-line", color: "text-gray-400", lastSync: "-", syncCount: 0 },
      ]
    },
    {
      category: "Comunicación",
      items: [
        { id: 8, name: "WhatsApp Business", description: "Notificaciones y comunicación con clientes", status: "Disponible", icon: "ri-whatsapp-line", color: "text-gray-400", lastSync: "-", syncCount: 0 },
        { id: 9, name: "Email Marketing", description: "Campañas y notificaciones por correo", status: "Disponible", icon: "ri-mail-send-line", color: "text-gray-400", lastSync: "-", syncCount: 0 },
      ]
    },
  ];

  const syncHistory = [
    { integration: "SAT - Facturación", status: "Exitoso", records: 45, timestamp: "2024-01-16 10:30:00" },
    { integration: "Bancos - Conciliación", status: "Exitoso", records: 128, timestamp: "2024-01-16 10:00:00" },
    { integration: "API Aduanas", status: "Exitoso", records: 23, timestamp: "2024-01-16 09:45:00" },
    { integration: "Buzón Tributario", status: "Exitoso", records: 5, timestamp: "2024-01-16 09:00:00" },
    { integration: "Ventanilla Única", status: "Error", records: 0, timestamp: "2024-01-16 08:30:00" },
  ];

  const handleConfigure = (integration: any) => {
    setSelectedIntegration(integration);
    setShowConfigModal(true);
  };

  const handleConnect = (integration: any) => {
    setSelectedIntegration(integration);
    setShowConnectModal(true);
  };

  const handleSaveConfig = () => {
    setShowConfigModal(false);
    showToast('Configuración guardada exitosamente');
  };

  const handleConnectIntegration = () => {
    setShowConnectModal(false);
    showToast(`${selectedIntegration?.name} conectado exitosamente`);
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Integraciones</h1>
            <p className="text-sm text-gray-500 mt-1">Conecta servicios externos con la plataforma</p>
          </div>
          <button className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:opacity-90 transition-opacity whitespace-nowrap flex items-center gap-2 cursor-pointer">
            <i className="ri-refresh-line"></i>
            Sincronizar Todo
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Integraciones Activas</p>
                <p className="text-2xl font-bold text-[#0A2A43]">5</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#10B981]/10">
                <i className="ri-plug-line text-2xl text-[#10B981]"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Disponibles</p>
                <p className="text-2xl font-bold text-[#0A2A43]">4</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-apps-line text-2xl text-[#2F80ED]"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Sincronizaciones Hoy</p>
                <p className="text-2xl font-bold text-[#0A2A43]">142</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-refresh-line text-2xl text-[#114B7A]"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">Última Sincronización</p>
                <p className="text-sm font-bold text-[#0A2A43]">Hace 5 min</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                <i className="ri-time-line text-2xl text-[#EAB308]"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 space-y-6">
            {integrations.map((category, index) => (
              <div key={index} className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-6">
                <h2 className="text-lg font-bold text-[#0A2A43] mb-4">{category.category}</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {category.items.map((item) => (
                    <div key={item.id} className="p-4 border border-gray-200 rounded-lg hover:border-[#2F80ED] hover:shadow-md transition-all">
                      <div className="flex items-start justify-between">
                        <div className="flex items-start gap-3 flex-1">
                          <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${item.status === 'Conectado' ? 'bg-[#10B981]/10' : 'bg-gray-100'}`}>
                            <i className={`${item.icon} text-2xl ${item.color}`}></i>
                          </div>
                          <div className="flex-1">
                            <h3 className="text-sm font-semibold text-[#0A2A43] mb-1">{item.name}</h3>
                            <p className="text-xs text-gray-500 mb-2">{item.description}</p>
                            <div className="flex items-center gap-2">
                              <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                                item.status === "Conectado" ? "bg-[#10B981]/10 text-[#10B981]" : "bg-gray-100 text-gray-600"
                              }`}>
                                <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${item.status === 'Conectado' ? 'bg-[#10B981]' : 'bg-gray-400'}`}></span>
                                {item.status}
                              </span>
                              {item.status === 'Conectado' && (
                                <span className="text-xs text-gray-400">{item.lastSync}</span>
                              )}
                            </div>
                          </div>
                        </div>
                        <button 
                          onClick={() => item.status === 'Conectado' ? handleConfigure(item) : handleConnect(item)}
                          className={`px-3 py-1.5 text-xs rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                            item.status === "Conectado"
                              ? "border border-[#2F80ED] text-[#2F80ED] hover:bg-[#EAF2F8]"
                              : "bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white hover:opacity-90"
                          }`}
                        >
                          {item.status === "Conectado" ? "Configurar" : "Conectar"}
                        </button>
                      </div>
                      {item.status === 'Conectado' && (
                        <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
                          <span className="text-xs text-gray-500">{item.syncCount.toLocaleString()} registros sincronizados</span>
                          <button className="text-xs text-[#2F80ED] hover:underline cursor-pointer whitespace-nowrap">
                            <i className="ri-refresh-line mr-1"></i>Sincronizar
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Historial de Sincronización */}
          <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)] p-6 h-fit">
            <h2 className="text-lg font-bold text-[#0A2A43] mb-4">Historial de Sincronización</h2>
            <div className="space-y-3">
              {syncHistory.map((sync, index) => (
                <div key={index} className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-[#0A2A43]">{sync.integration}</span>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded ${
                      sync.status === 'Exitoso' ? 'bg-[#10B981]/10 text-[#10B981]' : 'bg-[#EF4444]/10 text-[#EF4444]'
                    }`}>
                      {sync.status}
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-xs text-gray-500">
                    <span>{sync.records} registros</span>
                    <span>{sync.timestamp}</span>
                  </div>
                </div>
              ))}
            </div>
            <button className="w-full mt-4 py-2 text-sm font-medium text-[#2F80ED] hover:bg-[#EAF2F8] rounded-md transition-colors cursor-pointer whitespace-nowrap">
              Ver historial completo
            </button>
          </div>
        </div>
      </div>

      {/* Modal Configurar Integración */}
      {showConfigModal && selectedIntegration && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-lg mx-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-lg font-bold text-[#0A2A43]">Configurar {selectedIntegration.name}</h2>
              <button onClick={() => setShowConfigModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex items-center gap-4 p-4 bg-[#10B981]/10 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-white">
                  <i className={`${selectedIntegration.icon} text-2xl text-[#10B981]`}></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0A2A43]">{selectedIntegration.name}</p>
                  <p className="text-xs text-[#10B981]">Conectado • {selectedIntegration.lastSync}</p>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Frecuencia de Sincronización</label>
                <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]">
                  <option>Cada 5 minutos</option>
                  <option>Cada 15 minutos</option>
                  <option>Cada 30 minutos</option>
                  <option>Cada hora</option>
                  <option>Manual</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">API Key</label>
                <input type="password" defaultValue="••••••••••••••••" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <p className="text-sm font-medium text-[#0A2A43]">Sincronización Automática</p>
                  <p className="text-xs text-gray-500">Sincronizar datos automáticamente</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" defaultChecked className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#2F80ED]/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#2F80ED]"></div>
                </label>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <p className="text-sm font-medium text-[#0A2A43]">Notificaciones de Error</p>
                  <p className="text-xs text-gray-500">Recibir alertas cuando falle la sincronización</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" defaultChecked className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#2F80ED]/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#2F80ED]"></div>
                </label>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-between">
              <button className="px-4 py-2 text-[#EF4444] hover:bg-red-50 rounded-md cursor-pointer whitespace-nowrap">
                <i className="ri-link-unlink mr-2"></i>Desconectar
              </button>
              <div className="flex gap-3">
                <button onClick={() => setShowConfigModal(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                  Cancelar
                </button>
                <button onClick={handleSaveConfig} className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                  Guardar Cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Conectar Integración */}
      {showConnectModal && selectedIntegration && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-lg mx-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-lg font-bold text-[#0A2A43]">Conectar {selectedIntegration.name}</h2>
              <button onClick={() => setShowConnectModal(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-lg">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                  <i className={`${selectedIntegration.icon} text-2xl text-[#2F80ED]`}></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0A2A43]">{selectedIntegration.name}</p>
                  <p className="text-xs text-gray-500">{selectedIntegration.description}</p>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">API Key *</label>
                <input type="text" placeholder="Ingresa tu API Key" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">API Secret *</label>
                <input type="password" placeholder="Ingresa tu API Secret" className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED]" />
              </div>

              <div className="p-4 bg-[#EAF2F8] rounded-lg">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-[#2F80ED] text-lg"></i>
                  <div>
                    <p className="text-sm font-medium text-[#0A2A43]">¿Dónde encuentro mis credenciales?</p>
                    <p className="text-xs text-gray-600 mt-1">Puedes obtener tus credenciales de API desde el panel de administración del servicio correspondiente.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowConnectModal(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cancelar
              </button>
              <button onClick={handleConnectIntegration} className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                <i className="ri-link mr-2"></i>Conectar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {showSuccessToast && (
        <div className="fixed bottom-6 right-6 bg-[#10B981] text-white px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 z-50">
          <i className="ri-check-circle-line text-xl"></i>
          <span className="font-medium">{toastMessage}</span>
        </div>
      )}
    </Layout>
  );
}
